var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuStatisticsColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DE2727;}\n\t.st1{fill:#29B0FF;}\n\t.st2{fill:#2B8400;}\n\t.st3{fill:#FFBB00;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2141",
    transform: "translate(-212 -490.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_57",
    className: "st0",
    d: "M220.097,516.834v-6.296c0-1.579,1.275-2.854,2.854-2.854l0,0 c1.579,0,2.854,1.275,2.854,2.854v6.296c0,1.579-1.275,2.854-2.854,2.854l0,0C221.372,519.689,220.097,518.413,220.097,516.834z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_111",
    className: "st1",
    d: "M212,516.834v-12.368c0-1.579,1.275-2.854,2.854-2.854l0,0 c1.579,0,2.854,1.275,2.854,2.854v12.368c0,1.579-1.275,2.854-2.854,2.854l0,0C213.275,519.689,212,518.413,212,516.834z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_57-2",
    className: "st2",
    d: "M228.194,516.834V501.49c0-1.579,1.275-2.854,2.854-2.854l0,0 c1.579,0,2.854,1.275,2.854,2.854v15.344c0,1.579-1.275,2.854-2.854,2.854l0,0C229.47,519.689,228.194,518.413,228.194,516.834z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_57-3",
    className: "st3",
    d: "M236.291,516.834v-22.733c0-1.579,1.275-2.854,2.854-2.854l0,0 c1.579,0,2.854,1.275,2.854,2.854v22.733c0,1.579-1.275,2.854-2.854,2.854l0,0C237.567,519.689,236.291,518.413,236.291,516.834z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStatisticsColor);
export default __webpack_public_path__ + "static/media/menu-statistics-color.6cba40fdd89ee5116ed4dec3b644e7fe.svg";
export { ForwardRef as ReactComponent };